// assets
import { IconAddressBook, IconBrandX, IconChartFunnel, IconMail, IconUsersGroup } from '@tabler/icons-react';

// types
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS - GROWTH (P2-2) ||============================== //

const growth: NavItemType = {
  id: 'growth',
  title: 'growth', // react-intl key - i18n-ready [STD-DRIFT]
  icon: IconUsersGroup,
  type: 'group',
  requiredModule: 'growth',
  children: [
    {
      id: 'growth-contacts',
      title: 'growth-contacts',
      icon: IconAddressBook,
      type: 'item',
      url: '/growth/contacts',
      module: 'growth.contacts'
    },
    {
      id: 'growth-crm',
      title: 'growth-crm',
      icon: IconChartFunnel,
      type: 'item',
      url: '/growth/crm',
      module: 'growth.crm'
    },
    {
      id: 'growth-campaigns',
      title: 'growth-campaigns',
      icon: IconMail,
      type: 'item',
      url: '/growth/campaigns',
      module: 'growth.campaigns'
    },
    {
      id: 'growth-social',
      title: 'growth-social',
      icon: IconBrandX,
      type: 'item',
      url: '/growth/social',
      module: 'growth.social'
    }
  ]
};

export default growth;
